// Real display ad unit ("Intersticial Alerta AL", HTML format, responsive)
// created 2026-09-09. Auto ads is intentionally left off in the AdSense
// account for this site — it would bypass the premium check in
// maybeShowAd (App.jsx) and place ads even for paying users.
const AD_CLIENT_ID = "ca-pub-8497904971292340";
const AD_SLOT_ID = "1371099982";
const AD_COUNTDOWN_SEC = 3;

function InterstitialAd({ lang, onClose, willOpenExternal }) {
  const { Modal, Icon, Button } = window.VigiALDesignSystem_ff2dec;
  const [secondsLeft, setSecondsLeft] = React.useState(AD_COUNTDOWN_SEC);
  const canClose = secondsLeft <= 0;
  const hasRealAd = !!AD_SLOT_ID;

  React.useEffect(() => {
    if (secondsLeft <= 0) return;
    const timer = setTimeout(() => setSecondsLeft((s) => s - 1), 1000);
    return () => clearTimeout(timer);
  }, [secondsLeft]);

  React.useEffect(() => {
    if (!hasRealAd) return;
    // The AdSense SDK (~225KB) used to load unconditionally in index.html on
    // every single page view — most visitors (Premium users, anyone not
    // hitting an ad-gated tab) never see an ad and were paying that cost for
    // nothing. Injected here instead, only the first time a real ad is
    // actually about to render.
    if (!document.querySelector('script[src*="adsbygoogle.js"]')) {
      const s = document.createElement("script");
      s.src = `https://pagead2.googlesyndication.com/pagead/js/adsbygoogle.js?client=${AD_CLIENT_ID}`;
      s.async = true;
      s.crossOrigin = "anonymous";
      document.head.appendChild(s);
    }
    try {
      (window.adsbygoogle = window.adsbygoogle || []).push({});
    } catch (e) {}
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <Modal title={t(lang, "adTitle")} onClose={canClose ? onClose : () => {}} width={310}>
      <div style={{ margin: 16, borderRadius: "var(--radius-md)", overflow: "hidden", border: "1px solid var(--color-border)" }}>
        {hasRealAd ? (
          <ins
            className="adsbygoogle"
            style={{ display: "block", width: "100%", minHeight: 250 }}
            data-ad-client={AD_CLIENT_ID}
            data-ad-slot={AD_SLOT_ID}
            data-ad-format="auto"
            data-full-width-responsive="true"
          />
        ) : (
          <div style={{ background: "linear-gradient(135deg, var(--color-brand-primary), var(--color-brand-deep))", padding: "34px 16px", textAlign: "center", color: "#fff" }}>
            <Icon name="hourglass" size={26} color="#fff" />
            <div style={{ fontFamily: "var(--font-display)", fontWeight: 700, fontSize: "var(--text-md)", marginTop: 8 }}>{t(lang, "adPlaceholderHeadline")}</div>
            <div style={{ fontSize: "var(--text-sm)", opacity: 0.85, marginTop: 4 }}>{t(lang, "adPlaceholderBody")}</div>
          </div>
        )}
      </div>
      <div style={{ padding: "0 16px 16px", display: "flex", flexDirection: "column", gap: 8 }}>
        {willOpenExternal && (
          <div style={{ display: "flex", alignItems: "flex-start", gap: 6, background: "var(--color-brand-tint)", borderRadius: "var(--radius-md)", padding: "8px 10px" }}>
            <Icon name="arrow-left" size={14} color="var(--color-brand-deep)" />
            <span style={{ fontSize: "var(--text-xs)", color: "var(--color-brand-deep)" }}>{t(lang, "adArticleBackHint")}</span>
          </div>
        )}
        <span style={{ fontSize: "var(--text-xs)", color: "var(--color-text-muted)" }}>{t(lang, "adPremiumHint")}</span>
        <Button variant={canClose ? "primary" : "secondary"} disabled={!canClose} onClick={onClose} style={{ width: "100%" }}>
          {canClose ? t(lang, "adCloseBtn") : `${t(lang, "adWaitPrefix")} ${secondsLeft}s`}
        </Button>
      </div>
    </Modal>
  );
}
window.InterstitialAd = InterstitialAd;
